import {
  IModelItemValidationResult,
  IValidationResult,
  ModelGroup,
  ModelValidationResult,
  ValidationTypes
} from '@mng/model';

export class MngModelMessageHandler {
  messageFor(modelValidationResult: ModelValidationResult, onlyGroupError = false): string {
    if (modelValidationResult.validationResults && modelValidationResult.validationResults.length > 0) {
      // simple approach to use the first validation result
      if (!onlyGroupError) {
        return this.messageForItem(modelValidationResult.validationResults[0]);
      } else {
        const groupModelValidationResult: IModelItemValidationResult = modelValidationResult.validationResults.find(
          (result: IModelItemValidationResult) => result.item instanceof ModelGroup
        );
        if (groupModelValidationResult) {
          return this.messageForItem(groupModelValidationResult);
        }
      }
      return null;
    } else {
      return null;
    }
  }

  messageForItem(itemValidationResult: IModelItemValidationResult, withItemDesc = false): string {
    const validationResult: IValidationResult = itemValidationResult.validationResult;

    let result: string;

    if (validationResult.message) {
      return validationResult.message;
    }

    if (validationResult.id === ValidationTypes.REQUIRED) {
      result = 'Eine Eingabe ist notwendig';
    } else if (validationResult.id === ValidationTypes.MAXLENGTH) {
      result = `Die Eingabe ist zu lang (maximal ${itemValidationResult.item.options.maxlength} Zeichen)`;
    } else if (validationResult.id === ValidationTypes.MINLENGTH) {
      result = `Die Eingabe ist zu kurz (mindestens ${itemValidationResult.item.options.minlength} Zeichen)`;
    } else if (validationResult.id === ValidationTypes.MAXVALUE) {
      result = `Der Eingabewert ist zu gross  (max. ${itemValidationResult.item.options.maxvalue})`;
    } else if (validationResult.id === ValidationTypes.MINVALUE) {
      result = `Der Eingabewert ist zu klein (min. ${itemValidationResult.item.options.minvalue})`;
    } else {
      result = this.messageForId(validationResult.id);
    }

    if (withItemDesc) {
      const desc = itemValidationResult.item.description
        ? `<strong>${itemValidationResult.item.description}</strong> - `
        : '';
      result = `${desc}${result}`;
    }

    // console.log('messageForItem', validationResult, result);

    return result;
  }

  messageForId(id: string): string {
    switch (id) {
      case ValidationTypes.IBAN: {
        return 'Ungültige IBAN';
      }
      case ValidationTypes.BIC: {
        return 'Ungültiger BIC';
      }
      case ValidationTypes.DATE: {
        return 'Eingabe im Format TT.MM.YYYY';
      }
      case ValidationTypes.TIME: {
        return 'Eingabe im Format hh:mm';
      }
      case ValidationTypes.FZ_KONTO: {
        return 'Ungültige Gruppenvertragskontonummer';
      }
      default: {
        return '';
      }
    }
  }

  allMessages(modelValidationResult: ModelValidationResult): string[] {
    return modelValidationResult.validationResults.map((itemValidationResult: IModelItemValidationResult) =>
      this.messageForItem(itemValidationResult, true)
    );
  }
}

export const messageHandler = new MngModelMessageHandler();
